import Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';

interface RrPcTachogramProps {
  chartOptions: Highcharts.Options;
}

export const RrPcTachogram = ({ chartOptions }: RrPcTachogramProps) => {
  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};
